<script lang="ts" setup>
import { classMerge } from '@toni/brand-ui'

import { useClient } from '../../utils/client-only'
import BlockAdWrapper from './BlockAdWrapper.vue'

withDefaults(
  defineProps<{
  slotName: string,
  twClass?: string,
  float?: boolean,
  minWidth?: string,
  minHeight?: string
}>(),
  {
    twClass: '',
    float: false,
    minWidth: undefined,
    minHeight: undefined
  }
)

const { isClient } = useClient()
</script>

<template>
  <BlockAdWrapper v-if="isClient"
                  :data-ad-slot-name="slotName"
                  data-testid="ad-slot"
                  :slot-name="slotName"
                  :float="float"
                  :min-width="minWidth"
                  :min-height="minHeight">
    <div :class="classMerge('', twClass)">
      <div :id="slotName"
           class="MoltenBundle" />
    </div>
  </BlockAdWrapper>
</template>
